import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export async function startEvent(eventVaultId: number) {
  await axios.patch(`/api/event/${eventVaultId}/start`)
}

export function useStartEvent() {
  return useMutation({
    mutationFn: (eventVaultId: number) => startEvent(eventVaultId),
  })
}
